import { Plus, X } from "@phosphor-icons/react";
import { inputCls } from "@/lib/ui";
import { PALETTE } from "@/lib/format";

export const ParticipantsEditor = ({ value, onChange }) => {
  const update = (i, key, v) => onChange(value.map((p, j) => (j === i ? { ...p, [key]: v } : p)));
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const add = () => onChange([...value, { name: "", role: "", owns: "" }]);

  return (
    <div className="space-y-2" data-testid="participants-editor">
      {value.map((p, i) => (
        <div key={i} className="grid grid-cols-[6px_1fr_1fr_2fr_36px] gap-2 items-stretch" data-testid={`participant-row-${i}`}>
          <span style={{ background: PALETTE[i % PALETTE.length] }} />
          <input autoComplete="off" className={inputCls} placeholder="Name" value={p.name} onChange={(e) => update(i, "name", e.target.value)} data-testid={`participant-name-${i}`} />
          <input autoComplete="off" className={inputCls} placeholder="Role" value={p.role} onChange={(e) => update(i, "role", e.target.value)} data-testid={`participant-role-${i}`} />
          <input autoComplete="off" className={inputCls} placeholder="What they own, e.g. pipeline and the 20-customer outreach goal" value={p.owns} onChange={(e) => update(i, "owns", e.target.value)} data-testid={`participant-owns-${i}`} />
          <button type="button" onClick={() => remove(i)} className="border border-[var(--o-border)] text-[var(--o-muted2)] hover:text-[var(--o-fg)] hover:border-[var(--o-border-strong)] flex items-center justify-center transition-colors" data-testid={`participant-remove-${i}`}>
            <X size={14} />
          </button>
        </div>
      ))}
      <button type="button" onClick={add} className="flex items-center gap-2 text-sm text-[var(--o-muted)] hover:text-[var(--o-fg)] py-2 transition-colors" data-testid="participant-add-button">
        <Plus size={14} weight="bold" /> Add participant
      </button>
    </div>
  );
};
